// import { useEffect } from "react";
import { useAudioManager } from "@/hooks/use-audio-manager";

export enum AudioId {
  // 翻页动效
  TurnPage = 'turn-page',
  // 按钮点击动效
  ButtonClick = 'button-click',
  // 奖励到账
  RewardReceived = 'reward-received',
}

export const AUDIO_MAP = {
  [AudioId.TurnPage]: '/assets/audio-files/turn-page.mp3',
  [AudioId.ButtonClick]: '/assets/audio-files/tab-click.mp3',
  [AudioId.RewardReceived]: '/assets/audio-files/reward-received.m4a',
};

interface UseAudioHelperProps {
  id: AudioId;
}

export const useAudioHelper = (audioObj: UseAudioHelperProps) => {
  const { id } = audioObj;
  const { playSound } = useAudioManager();
  // useEffect(() => {
  //   audioManager.soundEffectManager.register(id, AUDIO_MAP[id]);
  //   setTimeout(() => {
  //     audioManager.soundEffectManager.preload(id);
  //   }, 100);
  // }, [audioManager, id]);

  const playAudio = (audioId?: AudioId, volume?: number) => {
    console.log('-----playAudio-------', id, audioId, volume, playSound);
    // playSound(audioId ? audioId : id, { volume: volume || 0.7 }).catch(console.error);
  };
  return {
    playAudio,
  };
};